export const nationalities = [
  'Argentina',
  'Brasileña',
  'Chilena',
  'Colombiana',
  'Francesa',
  'Italiana',
  'Paraguaya',
  'Uruguaya',
  'Venozelana',
]
